import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../services/api';

// Типы для сертификата
export interface Certificate {
  id: number;
  name: string;
  cost_rub: number;
  first_batch_share_percent: number;
  first_batch_expenses_rub: number;
}

// Типы для состояния сертификатов
interface CertificatesState {
  certificates: Certificate[];
  loading: boolean;
  error: string | null;
}

// Асинхронные действия
export const fetchCertificates = createAsyncThunk(
  'certificates/fetchCertificates',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/certificates');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch certificates');
    }
  }
);

// Начальное состояние
const initialState: CertificatesState = {
  certificates: [],
  loading: false,
  error: null,
};

// Слайс сертификатов
const certificatesSlice = createSlice({
  name: 'certificates',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch certificates
      .addCase(fetchCertificates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCertificates.fulfilled, (state, action) => {
        state.loading = false;
        state.certificates = action.payload.data || [];
      })
      .addCase(fetchCertificates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setLoading } = certificatesSlice.actions;
export default certificatesSlice.reducer;
